import { integracaoContabilApi } from '@/api/IntegracaoContabilApi';
import { RelatorioServicosSaudeModel } from '@/models/administracao/servicos-saude/RelatorioServicosSaudeModel';

export default class GerencialServicosSaudeService {

    static gerarRelatorio(tipo: string, request: RelatorioServicosSaudeModel) {
        return integracaoContabilApi.gerarRelatorioServicosSaude(tipo, request);
    }
}